export default "__VITE_ASSET__61008506__"